import { useFormikContext } from "formik";

import TextField from "@mui/material/TextField";

export default function TextInput({ hideError, label, name, ...props }) {
  const { values, errors, handleChange } = useFormikContext();

  return (
    <TextField
      // dasherizes label
      /* id={`${label.replace(/\s+/g, "-")}-input`} */
      id={name}
      fullWidth
      error={!hideError && !!errors[name]}
      helperText={!hideError && errors[name] && `${label} is required`}
      // camel case of input
      name={name}
      value={values[name] || ""}
      onChange={handleChange}
      label={label}
      variant="outlined"
      {...props}
    />
  );
}
